<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Claims'
}
</script>



// WEBPACK FOOTER //
// src/components/Claims.vue